// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ssLR0","col":"styles_col__EDvdK"};